export default __webpack_public_path__ + "static/media/10.2549a4cf.jpg";